import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-commercial',
  templateUrl: './product-commercial.component.html',
  styleUrls: ['./product-commercial.component.css']
})
export class ProductCommercialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
